import React from "react";
import { CandleStickChart } from "../../Charts/CandleStickChart";
import { useTransformedChartData } from "../../../hooks/useTransformedChartData";
import { Address } from "viem";
import styled from "@emotion/styled";

interface TokenSelectorPreviewChartProps {
  tokenAddress: Address;
}

export const TokenSelectorPreviewChart = (props: TokenSelectorPreviewChartProps) => {
  const [isLineChartSelected] = React.useState<boolean>(false);
  const { transformedChartData, isError } = useTransformedChartData(props.tokenAddress);

  return (
    <TokenSelectorPreviewChartContainer>
      {!isLineChartSelected && (
        <CandleStickChart
          data={transformedChartData}
          id={props.tokenAddress}
          isError={isError}
          height={127}
        />
      )}
      {isLineChartSelected && <div>Line Chart</div>}
    </TokenSelectorPreviewChartContainer>
  );
};

const TokenSelectorPreviewChartContainer = styled.div`
  width: 100%;
  padding-bottom: 14px;
`;
